module.exports = __webpack_public_path__ + "img/raffle-cropped-white.3efb78e9.png";